module.exports = __webpack_public_path__ + "img/icon-arrow-download.de108504.svg";